import React, { ReactNode } from "react";

export interface IButtonTextProps {
  size?: "sm" | "md";
  children: ReactNode;
}

export const ButtonText: React.FC<IButtonTextProps> = ({ size = "sm", children }) => {
  const classNames = {
    sm: "text-sm leading-4 font-medium",
    md: "text-base leading-5 font-medium",
  };

  return <div className={`${classNames[size]} truncate`}>{children}</div>;
};
